var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdpLogoLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 70 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d0271d}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 15.9a9.13 9.13 0 0 1-9.1 9.1h-3.5v-4h3.5a5.1 5.1 0 1 0 0-10.2h-3.5v-4h3.5a9.13 9.13 0 0 1 9.1 9.1M24.6 6.8v7.4h-6.3l-2.3 4h12.6V6.8ZM70 12.5A12.5 12.5 0 0 1 57.5 25v6.8H46.7v-5.3a15.64 15.64 0 0 1-11.9 5.3H24.6V25h-8l-4 6.8H0L18.5 0h16.4a16.32 16.32 0 0 1 11.9 5.3V0h10.8A12.48 12.48 0 0 1 70 12.5M34.9 27.8A11.93 11.93 0 0 0 45.7 21h5.1v6.8h2.8V21h4a8.49 8.49 0 0 0 8.5-8.5A8.58 8.58 0 0 0 57.5 4h-6.8v10.2h-4A12 12 0 0 0 34.9 4h-14L7 27.8h3.3l4-6.8h14.3v6.8Zm22.6-21h-4v4h4a1.69 1.69 0 0 1 1.7 1.7 1.75 1.75 0 0 1-1.7 1.7h-4v4h4a5.7 5.7 0 0 0 5.7-5.7 5.76 5.76 0 0 0-5.7-5.7",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1 29.8a1.6 1.6 0 1 1-1.6-1.6 1.58 1.58 0 0 1 1.6 1.6m.4 0a2 2 0 1 0-2 2 2 2 0 0 0 2-2",
    className: "cls-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6 28.9a.4.4 0 1 1 0 .8h-.4v-.8Zm.5-.1a.76.76 0 0 0-.5-.2h-.8V31h.3v-.9h.4l.5.9h.4l-.6-1c.1 0 .2-.1.3-.2a.6.6 0 0 0 .1-.4.56.56 0 0 0-.1-.6",
    className: "cls-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdpLogoLarge);
export default __webpack_public_path__ + "static/media/adpLogoLarge.33ecf672752f2854a2539fa55b974283.svg";
export { ForwardRef as ReactComponent };